/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_Gym_LabelInputs */

const en_us2_quick_workout_gym_label = /** @type {(inputs: Quick_Workout_Gym_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where are you training?`)
};

const pt_br2_quick_workout_gym_label = /** @type {(inputs: Quick_Workout_Gym_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde você vai treinar?`)
};

const es_419_quick_workout_gym_label = /** @type {(inputs: Quick_Workout_Gym_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Dónde vas a entrenar?`)
};

const pt_pt2_quick_workout_gym_label = /** @type {(inputs: Quick_Workout_Gym_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde vais treinar?`)
};

const fr_fr2_quick_workout_gym_label = /** @type {(inputs: Quick_Workout_Gym_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où t'entraînes-tu ?`)
};

const de_de2_quick_workout_gym_label = /** @type {(inputs: Quick_Workout_Gym_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo trainierst du?`)
};

const it_it2_quick_workout_gym_label = /** @type {(inputs: Quick_Workout_Gym_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove ti alleni?`)
};

/**
* | output |
* | --- |
* | "Where are you training?" |
*
* @param {Quick_Workout_Gym_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_gym_label = /** @type {((inputs?: Quick_Workout_Gym_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Gym_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_gym_label(inputs)
	if (locale === "es-419") return es_419_quick_workout_gym_label(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_gym_label(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_gym_label(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_gym_label(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_gym_label(inputs)
	return en_us2_quick_workout_gym_label(inputs)
});
export { quick_workout_gym_label as "quick-workout.gym_label" }